module.exports = __webpack_public_path__ + "static/img/upload.b443b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/fourthToolList/upload.png
// module id = fhSp
// module chunks = 4